export declare namespace CheckRadioTokenSections {
	interface Checked {
		background: string;
		borderColor: string;
	}

	interface Unchecked {
		borderColor: string;
	}

	interface Dot {
		background: string;
		color: string;
	}
}

export type CheckRadioTokens = {
	checked: CheckRadioTokenSections.Checked;
	unchecked: CheckRadioTokenSections.Unchecked;
	dot: CheckRadioTokenSections.Dot;
};

export const checked: CheckRadioTokenSections.Checked = {
	background: '{primary.color}',
	borderColor: '{primary.color}',
};

export const unchecked: CheckRadioTokenSections.Unchecked = { borderColor: '{surface.100}' };

export const dot: CheckRadioTokenSections.Dot = {
	background: '{content.background}',
	color: '{primary.contrast.color}',
};

/** `app-check-radio` box and dot colours (`css/checkRadio`). */
export default {
	checked,
	unchecked,
	dot,
} satisfies CheckRadioTokens;
